import React, { useCallback, useMemo, useState } from 'react';
import PipelineSummary from './PipelineSummary';
import ProgrammeHealth from './ProgrammeHealth';
import SchedulePreview from './SchedulePreview';
import TestPeekModal from '../TestingBoard/TestPeekModal';
import { buildSchedule } from '../Schedule/scheduleData';
import { useEPMContext } from '../../../contexts/EPMContext';
import { useUserContext } from '../../../contexts/UserContext';
import { permission } from '../../../config/permission';

const Home = () => {
    const { tests, testLocations = [] } = useEPMContext();
    const { checkPermission } = useUserContext();
    const [peekTestId, setPeekTestId] = useState(null);
    const closePeek = useCallback(() => setPeekTestId(null), []);

    const sortedLocations = useMemo(
        () => [...testLocations].sort((a, b) => Number(a.order || 0) - Number(b.order || 0)),
        [testLocations]
    );
    const schedule = useMemo(
        () => buildSchedule(tests, { testLocations: sortedLocations }),
        [tests, sortedLocations]
    );

    return (
        <main className="w-full px-4 md:px-8 py-6 space-y-6 min-h-screen" aria-label="XCM overview">
            <PipelineSummary />
            {checkPermission(permission.XCM_SCHEDULE_VIEW) && (
                <SchedulePreview schedule={schedule} onOpenTest={setPeekTestId} />
            )}
            {checkPermission(permission.XCM_PROGRAMME_HEALTH_VIEW) && (
                <ProgrammeHealth />
            )}
            {peekTestId && <TestPeekModal testId={peekTestId} onClose={closePeek} />}
        </main>
    );
};

export default Home;
